import { Suspense, lazy, ElementType } from "react";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
//
import PATHS from "@routes/paths";
import LoadingScreen from "@components/LoadingScreen";

// ----------------------------------------------------------------------
import AuthGuard from "@/guards/AuthGuard";
import Register from "@pages/auth/Register";
import Navbar from "@components/Navbar";
import GuestGuard from "@/guards/GuestGuard";
import Layout from "@components/Layout";
import StrategicPlanning from "@pages/strategicPlanning";
import Leads from "@pages/Dashboard/leads";
import TargetMarkets from "@pages/targetMarkets";
import CampaignMessages from "@pages/campaignMessages";
import Blacklist from "@pages/blacklist";
import Settings from "@pages/settings";
import EmailAccounts from "@pages/emailAccounts";
import AddEmailAccount from "@pages/emailAccounts/addEmailAccount";
import TargetMarketDetail from "@pages/targetMarkets/targetMarketDetail";
import MessageDetail from "@pages/campaignMessages/messageDetail";
import EmailAccountsById from "@pages/emailAccounts/emailAccountsById";
import Icps from "@pages/strategicPlanning/icp/Icps";
import AddIcp from "@pages/strategicPlanning/icp/AddIcp";
import EditIcp from "@pages/strategicPlanning/icp/EditIcp";
import Readme from "@pages/strategicPlanning/icp/Readme";
import Vps from "@pages/strategicPlanning/vps";
import AddVps from "@pages/strategicPlanning/vps/AddVps";
import EditVps from "@pages/strategicPlanning/vps/EditVps";
import ReadmeVps from "@pages/strategicPlanning/vps/Readme";
import BMA from "@pages/strategicPlanning/bma";
import AddBma from "@pages/strategicPlanning/bma/AddBma";
import EditBma from "@pages/strategicPlanning/bma/EditBma";
import ReadmeBma from "@pages/strategicPlanning/bma/ReadmeBma";
import AddDomain from "@pages/blacklist/addDomain";
import EditDomain from "@pages/blacklist/editDomain";
import Users from "@pages/strategicPlanning/users";
import Users1 from "@pages/blacklist/users";
import Users2 from "@pages/campaignMessages/users";
import PublishedMessage from "@pages/campaignMessages/publishedMessages";
import EditEmailAccount from "@pages/emailAccounts/editEmailAccount";
import TeamMembers from "@pages/settings/InvitedMembers";
import NotificationsPage from "../pages/notificationspage/index";
import ResetPassword from "@/resetPassword";
// import Notifications from "@redux/slices/notifications";
// import Notifications from "@pages/notifications";

// ----------------------------------------------------------------------
const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------
const Dashboard = Loadable(lazy(() => import("@pages/Dashboard")));
const Login = Loadable(lazy(() => import("@pages/auth/Login")));
const Validate = Loadable(lazy(() => import("@pages/auth/Validate")));

// ----------------------------------------------------------------------
export default function Router() {
  return (
    <Routes>
     
      <Route path="/" element={<Navigate to="/dashboard" replace={false} />} />

      {/* Guest routes */}
      <Route element={<GuestGuard />}>
        <Route path={PATHS.login} element={<Login />} />
        <Route path={PATHS.register} element={<Register />} />
      

<Route path="/resetPassword" element={<ResetPassword />} />
         
        {/* Allow access to reset password page */}
      </Route>
      <Route path={PATHS.validate} element={<Validate />} />
      <Route path={PATHS.root} element={<Dashboard />} />

      <Route
        path={PATHS.root}
        element={
          <AuthGuard>
            <Layout />
          </AuthGuard>
        }
      >
        <Route index path="/dashboard" element={<Dashboard />} />
        <Route index path="/notifications" element={<NotificationsPage />} />
        <Route path="/strategicPlanning" element={<StrategicPlanning />} />
        <Route path="/users/:id" element={<Users />} />
        <Route path="/bUsers" element={<Users1 />} />

        {/* // new here */}
       
        {/* new here */}

        <Route path="/strategicPlanning/icps/:id" element={<Icps />} />
        <Route path="/strategicPlanning/addIcp" element={<AddIcp />} />
        <Route path="/strategicPlanning/editIcp/:id" element={<EditIcp />} />
        <Route path="/strategicPlanning/readmeIcp" element={<Readme />} />

        <Route path="/strategicPlanning/vps/:id" element={<Vps />} />
        <Route path="/strategicPlanning/addVps" element={<AddVps />} />
        <Route path="/strategicPlanning/editVps/:id" element={<EditVps />} />
        <Route
          path="/strategicPlanning/readmeVps/:id"
          element={<ReadmeVps />}
        />

        <Route path="/strategicPlanning/bma/:id" element={<BMA />} />
        <Route path="/strategicPlanning/addBma" element={<AddBma />} />
        <Route path="/strategicPlanning/editBma/:id" element={<EditBma />} />
        <Route
          path="/strategicPlanning/readmeBma/:id"
          element={<ReadmeBma />}
        />

        <Route path="/targetMarkets/:id" element={<TargetMarkets />} />
        <Route
          path="/targetMarkets/targetMarketDetail/:id"
          element={<TargetMarketDetail />}
        />

        <Route path="/campaignMessages" element={<CampaignMessages />} />
        <Route
          path="campaignMessages/campaignMessageDetail/:id"
          element={<MessageDetail />}
        />
        <Route
          path="campaignMessages/publishedMessages/:campaign/:id"
          element={<PublishedMessage />}
        />

        <Route path="/cusers/:id/:id" element={<Users2 />} />
        <Route path="/blacklist/:id" element={<Blacklist />} />

        <Route path="/emailAccounts" element={<EmailAccounts />} />
        <Route path="/emailAccounts/:id" element={<EmailAccountsById />} />
        <Route
          path="/emailAccounts/addEmailAccount"
          element={<AddEmailAccount />}
        />
        <Route
          path="/emailAccounts/editEmailAccount/:id"
          element={<EditEmailAccount />}
        />

        <Route path="/settings" element={<Settings />} />
        <Route path="/blacklist/addDomain" element={<AddDomain />} />
        <Route path="/blacklist/editDomain/:id" element={<EditDomain />} />
        <Route path="/invitedMembers" element={<TeamMembers />} />

        <Route path="/leads/:category" element={<Leads />} />
      </Route>
    </Routes>
  );
}
